<template>
  <section class="mb-5 position-relative flex-grow-1 flex-shrink-0">
    <div class="banner-main no-navigation" :style="'background-image: url(' + translatedConfig('bannerUrl') + ')'" />

    <b-container class="pt-2">
      <b-row>
        <b-col cols="12" class="pt-4">
          <h1 class="py-4 mt-4 mb-5 mb-lg-4 text-white d-flex align-items-center justify-content-center flex-column flex-sm-row"
              data-test-id="component-title"
          >
            {{ "componentTitle" | translate(labels, 'ContactUs') }}
          </h1>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" class="mt-md-1 mt-lg-4 pt-lg-1">
          <BasicBreadcrumb />
        </b-col>
      </b-row>

      <div v-if="loading" class="d-flex w-100 align-items-center justify-content-center py-5 my-5">
        <b-spinner variant="primary" class="mb-5" />
      </div>

      <template v-else>
        <b-row>
          <b-col cols="12" class="mb-3">
            <h2>{{ "headerTitle" | translate(labels, 'ContactUs') }}</h2>
            <div class="font-condensed" v-html="translatedLabel('headerSubtitle', 'ContactUs')" />
          </b-col>
        </b-row>

        <b-row align-content="stretch">
          <b-col cols="12" md="4" class="mb-3">
            <div class="box mb-3 h-100 d-flex flex-column">
              <div class="flex-grow-1">
                <h2>{{ "serviceSupportTitle" | translate(labels, 'ContactUs') }}</h2>
                <p>{{ "serviceSupportSubtitle" | translate(labels, 'ContactUs') }}</p>
              </div>
              <div>
                <a :href="'tel:'+extractPhone(translatedLabel('serviceSupportPhoneNumber', 'ContactUs'))"
                   class="font-condensed text-black mb-3 d-block"
                >
                  <b-icon icon="phone-alt" class="mr-2" />
                  {{ "serviceSupportPhoneNumber" | translate(labels, 'ContactUs') }}
                </a>
                <p class="font-condensed mb-3">
                  <b-icon icon="clock" class="mr-2" />
                  {{ "serviceSupportBusinessHours" | translate(labels, 'ContactUs') }}
                </p>
              </div>
            </div>
          </b-col>

          <b-col cols="12" md="4" class="mb-3">
            <div class="box mb-3 h-100 d-flex flex-column">
              <div class="flex-grow-1">
                <h2>{{ "partsSupportTitle" | translate(labels, 'ContactUs') }}</h2>
                <p>{{ "partsSupportSubtitle" | translate(labels, 'ContactUs') }}</p>
              </div>
              <div>
                <a :href="'tel:'+extractPhone(translatedLabel('partsSupportPhoneNumber', 'ContactUs'))"
                   class="font-condensed text-black mb-3 d-block"
                >
                  <b-icon icon="phone-alt" class="mr-2" />
                  {{ "partsSupportPhoneNumber" | translate(labels, 'ContactUs') }}
                </a>
                <p class="font-condensed mb-3">
                  <b-icon icon="clock" class="mr-2" />
                  {{ "partsSupportBusinessHours" | translate(labels, 'ContactUs') }}
                </p>
                <a :href="'mailto:'+translatedLabel('partsSupportEmail', 'ContactUs')"
                   class="font-condensed text-black mb-3 d-block"
                >
                  <b-icon icon="paper-plane" class="mr-2" />
                  {{ "partsSupportEmail" | translate(labels, 'ContactUs') }}
                </a>
              </div>
            </div>
          </b-col>

          <b-col cols="12" md="4" class="mb-3">
            <div class="box mb-3 h-100 d-flex flex-column">
              <div class="flex-grow-1">
                <h2>{{ "ITSupportTitle" | translate(labels, 'ContactUs') }}</h2>
                <p>{{ "ITSupportSubtitle" | translate(labels, 'ContactUs') }}</p>
              </div>
              <div>
                <a :href="'tel:'+extractPhone(translatedLabel('ITSupportPhoneNumber', 'ContactUs'))"
                   class="font-condensed text-black mb-3 d-block"
                >
                  <b-icon icon="phone-alt" class="mr-2" />
                  {{ "ITSupportPhoneNumber" | translate(labels, 'ContactUs') }}
                </a>
                <b-btn variant="primary"
                       target="_blank"
                       class="mb-3"
                       :href="componentConfig.chatUrl"
                >
                  <b-icon icon="comments" class="mr-2" />
                  {{ "ITSupportButton" | translate(labels, 'ContactUs') }}
                </b-btn>
              </div>
            </div>
          </b-col>
        </b-row>
      </template>
    </b-container>
  </section>
</template>

<script>
import BasicBreadcrumb from '@/components/common/BasicBreadcrumb'

export default {
  conceptName: ['ContactUs'],
  components: {
    BasicBreadcrumb
  },
  data() {
    return {
      componentConfig: this.config
    }
  },
  computed: {
    loading() {
      return !Object.keys(this.labels).length
    }
  },
  methods: {
    extractPhone(tel) {
      return tel ? tel.replace('-', '').replace('(', '').replace(')', '').replace(' ', '') : null
    }
  }
}
</script>
